// extracted by mini-css-extract-plugin
export default {"rank_list":"index_rank_list_uoN-V","sRed":"index_sRed_s3KCn","box300":"index_box300_EtMHL"};